import { render } from "./FormHomeHeader.vue?vue&type=template&id=0a97519a&scoped=true"
import script from "./FormHomeHeader.vue?vue&type=script&lang=js"
export * from "./FormHomeHeader.vue?vue&type=script&lang=js"

import "./FormHomeHeader.vue?vue&type=style&index=0&id=0a97519a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a97519a"

export default script